import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  DatePicker,
  Input,
  message,
  Row,
  Spin,
  Table,
  Select,
  Divider,
} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import DynamicSelectOption from '../../components/DynamicSelectOption/DynamicSelectOption';
import { useEffect, useState } from 'react';
import { API, BEARER } from '../../constant';
import { getToken } from '../../helpers';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, Link } from 'react-router-dom';
import { monthNames } from '../../utils/dateUtils';
import { getUserDetails } from '../../helpers';
import { CSVLink } from 'react-csv';
import { toProperCase } from '../../utils/generic';
import { errorHandler } from '../../utils/errorHandling';

const userRoleAndPermission = require('../../config/userPermision.json');

const userRolesAllowedForFeature = {
  edit: {
    allHeadOnlyAttribute: [
      ...userRoleAndPermission?.userRole?.headTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
      ...userRoleAndPermission?.userRole?.brandTeam,
    ],
    designHeadAttribute: [
      ...userRoleAndPermission?.userRole?.designHead,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    designAttribute: [
      ...userRoleAndPermission?.userRole?.designTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    merchAttribute: [
      ...userRoleAndPermission?.userRole?.merchTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    planningAttribute: [
      ...userRoleAndPermission?.userRole?.planningTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    launchInformation: [
      ...userRoleAndPermission?.userRole?.designTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
      ...userRoleAndPermission?.userRole?.planningTeamRole,
    ],
  },
  view: {
    generateDoc: [
      ...userRoleAndPermission?.userRole?.adminTeamRole,
      ...userRoleAndPermission?.userRole?.techTeamRole,
    ],
  },
};

const filterGlobalSearch = (Data, searchText, filterScope) => {
  if (!searchText) {
    return Data;
  }

  let filteredDataTemp = [];
  if (filterScope == 'all') {
    filteredDataTemp = Data.filter((value) => {
      console.log(value, 'fab value filter');
      return (
        value?.launchName?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        value?.launchMonth
          ?.toLowerCase()
          ?.includes(searchText?.toLowerCase()) ||
        value?.launchCat?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        value?.seasonDetails?.seasonID
          ?.toLowerCase()
          ?.includes(searchText?.toLowerCase()) ||
        value?.launchId?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        value?.launchDrop?.toLowerCase()?.includes(searchText?.toLowerCase())
      );
    });
  } else if (filterScope == 'launchName') {
    filteredDataTemp = Data.filter((value) => {
      return value?.launchName
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase());
    });
  } else if (filterScope == 'launchMonth') {
    filteredDataTemp = Data?.filter((value) => {
      return value?.launchMonth
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase());
    });
  } else if (filterScope == 'launchCat') {
    filteredDataTemp = Data?.filter((value) => {
      return value?.launchCat
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase());
    });
  } else if (filterScope == 'launchSeason') {
    filteredDataTemp = Data?.filter((value) => {
      return value?.launchSeason
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase());
    });
  } else if (filterScope == 'launchDrop') {
    filteredDataTemp = Data.filter((value) => {
      return value?.launchDrop
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase());
    });
  }

  console.log(filteredDataTemp, 'filtered data', filterScope, searchText);
  if (filteredDataTemp.length > 0) {
    return filteredDataTemp;
  } else {
    filteredDataTemp.push({
      key: 0,
      id: 0,
      launchName: 'Not Found',
      launchDate: 'Not Found',
      launchMonth: 'Not Found',
      launchSeason: 'Not Found',
      launchDrop: 'Not Found',
      launchCat: '0',
    });
    return filteredDataTemp;
  }
};

const LaunchMaster = () => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  // Edit Data for editing existing record
  const [editData, setEditData] = useState(null);

  const [isLoading, setIsLoading] = useState(null);
  const authToken = getToken();
  const [Data, setData] = useState([]);
  const [dataform] = Form.useForm();
  const [showForm, setShowForm] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const dateFormat = 'YYYY-MM-DD';
  const [optionList, setOptionList] = useState([]);
  const [filterInfo, setFilterInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState('');
  //filter global
  const [searchText, setSearchText] = useState('');
  const [filterScope, setFilterScope] = useState('all');

  const [alreadySelectedRows, setAlreadySelectedRows] = useState([]);

  const filterScopeOptionsArray = [
    'all',
    'launchName',
    'launchMonth',
    'launchSeason',
    'launchDrop',
    'launchCat',
  ];

  const user = getUserDetails();
  console.log(user, '48');

  const toGenerateSheet = (state) => {
    navigate('/generateSheets', { state });
  };

  // search table
  const handleSearch = async (event) => {
    console.log(event);
    globalSearch(searchInput);
  };

  const globalSearch = async (searchValue) => {
    if (searchValue === '') {
      // fetchDesignMaster(getToken());
    } else {
      setIsLoading(true);
      let data1 = [];
      try {
        const response = await fetch(
          `${API}/launch-masters?filters[$or][0][launchName][$containsi]=${searchValue}&filters[$or][1][season][season_id][$containsi]=${searchValue}&pagination[page]=1&pagination[pageSize]=${pageSize}&populate[season][fields][0]=season_id&sort=createdAt:desc`,
          {
            headers: { Authorization: `${BEARER} ${getToken()}` },
          },
        );
        const designMasterData = await response.json();
        if (designMasterData.error) {
          errorHandler(
            designMasterData,
            message,
            'Unable to fetch Records, please try again later',
          );
          // message.error('Unable to fetch Records, please try again later.');
        } else {
          data1 = designMasterData.data.map((entry) => {
            let seasonRefId = entry.attributes.season.data?.id;
            let season_id = entry.attributes.season.data?.attributes.season_id;
            let launchSeasonObj = {};
            if (seasonRefId && season_id)
              launchSeasonObj = {
                seasonRefId: seasonRefId,
                season_id: season_id,
              };
            return {
              id: entry.id,
              launchName: entry.attributes.launchName,
              launchId: entry.attributes.launchId,
              launchDate: entry.attributes.launchDate,
              launchMonth: entry.attributes.launchMonth,
              launchSeason: launchSeasonObj,
              launchDrop: entry.attributes.launchDrop,
              launchCat: entry.attributes.launchCat,
              merch_complete_date: entry?.attributes?.merch_complete_date,
              design_complete_date: entry?.attributes?.design_complete_date,
              planning_complete_date: entry?.attributes?.planning_complete_date,
            };
          });
          console.log('original Data:', designMasterData);
          console.log('Data:', data1);
          setData(data1);
          setTotal(designMasterData.meta.pagination.total);
          setPageSize(designMasterData.meta.pagination.pageSize);
          setPageCount(designMasterData.meta.pagination.pageCount);
        }
      } catch (error) {
        console.error(error);
        message.error('Error while fetching Data!');
      } finally {
        setIsLoading(false);
      }
    }
  };

  // search table

  // on every page change by the user
  const onPageChange = async (page) => {
    setIsLoading(true);
    console.log(page, pageSize);
    setCurrent(page);

    let data2 = [];
    try {
      const pagin_response = await fetch(
        `${API}/launch-masters?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate[season][fields][0]=season_id&sort=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${getToken()}` },
        },
      );
      const paginationData = await pagin_response.json();

      if (paginationData.error) {
        errorHandler(paginationData, message);
      } else {
        data2 = paginationData.data.map((entry) => {
          let seasonRefId = entry.attributes.season.data?.id;
          let season_id = entry.attributes.season.data?.attributes.season_id;
          let launchSeasonObj = {};
          if (seasonRefId && season_id)
            launchSeasonObj = {
              seasonRefId: seasonRefId,
              season_id: season_id,
            };

          return {
            id: entry.id,
            launchName: entry.attributes.launchName,
            launchId: entry.attributes.launchId,
            launchDate: entry.attributes.launchDate,
            launchMonth: entry.attributes.launchMonth,
            launchSeason: launchSeasonObj,
            launchDrop: entry.attributes.launchDrop,
            launchCat: entry.attributes.launchCat,
          };
        });
        console.log('original Data:', paginationData);
        console.log('Data:', data2);
        setData(data2);
        // let page = paginationData.meta.pagination.page;

        setTotal(paginationData.meta.pagination.total);
        setPageSize(paginationData.meta.pagination.pageSize);
        setPageCount(paginationData.meta.pagination.pageCount);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  let data1 = [];

  const fetchDesignMaster = async (token) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/launch-masters?pagination[page]=${current}&pagination[pageSize]=${pageSize}&populate[season][fields][0]=season_id&sort=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const designMasterData = await response.json();
      if (designMasterData.error) {
        errorHandler(designMasterData, message);
      } else {
        console.log('originalq Data:', designMasterData);
        return;
        data1 = designMasterData.data.map((entry) => {
          let seasonRefId = entry.attributes.season.data?.id;
          let season_id = entry.attributes.season.data?.attributes.season_id;
          let launchSeasonObj = {};
          if (seasonRefId && season_id)
            launchSeasonObj = {
              seasonRefId: seasonRefId,
              season_id: season_id,
            };
          return {
            id: entry.id,
            launchName: entry.attributes.launchName,
            launchId: entry.attributes.launchId,
            launchDate: entry.attributes.launchDate,
            launchMonth: entry.attributes.launchMonth,
            launchSeason: launchSeasonObj,
            launchDrop: entry.attributes.launchDrop,
            launchCat: entry.attributes.launchCat,
          };
        });
        console.log('original Data:', designMasterData);
        console.log('Data:', data1);
        setData(data1);

        setTotal(designMasterData.meta.pagination.total);
        setPageSize(designMasterData.meta.pagination.pageSize);
        setPageCount(designMasterData.meta.pagination.pageCount);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const getUserdDetailsCreatedBy = async (entry, contentTypeName) => {
    const userDetailsResponse = await fetch(
      `${API}/auditlogs?filters[$and][0][contentType][$eq]=${contentTypeName}&filters[$and][0][activity][$eq]=create&filters[$and][0][resourceId][$eq]=${entry?.id}&sort=createdAt:desc`,
      {
        headers: { Authorization: `${BEARER} ${getToken()}` },
      },
    );
    const userDetailsResponseData = await userDetailsResponse.json();
    console.log(
      userDetailsResponseData,
      'userDetailsResponse check',
      'Resouce Details',
      entry?.id,
    );

    return {
      userRefId: userDetailsResponseData?.data[0]?.attributes?.user?.id,
      userName: userDetailsResponseData?.data[0]?.attributes?.user?.username,
      userEmail: userDetailsResponseData?.data[0]?.attributes?.user?.email,
    };
  };

  const fetchData = async (token) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/launch-masters?populate[0]=season&sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const responseData = await response.json();
      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        // return;
        data1 = await Promise.all(
          responseData.data.map(async (entry) => {
            console.log(responseData, 'response check');

            // Fetch User Details
            const userDetails = await getUserdDetailsCreatedBy(
              entry,
              'launch-masters',
            );
            // End Fetch User Details

            let seasonObj = {};
            if (entry?.attributes?.season?.data?.id) {
              const seasonData = entry?.attributes?.season?.data;
              seasonObj = {
                seasonRefId: seasonData?.id,
                seasonID: seasonData?.attributes?.season_id,
                seasonType: seasonData?.attributes?.seasonType,
              };
            }
            // return;
            return {
              key: entry.id,
              id: entry.id,
              launchName: entry?.attributes?.launchName,
              launchMonth: entry?.attributes?.launchMonth,
              launchDrop: entry?.attributes?.launchDrop,
              launchCat: entry?.attributes?.launchCat,
              launchDate: entry?.attributes?.launchDate,
              movedLaunchDate: entry?.attributes?.moved_launch_date,
              business_date: entry?.attributes?.business_date,
              seasonDetails: seasonObj,
              userDetails: userDetails,
              merch_complete_date: entry?.attributes?.merch_complete_date,
              design_complete_date: entry?.attributes?.design_complete_date,
              planning_complete_date: entry?.attributes?.planning_complete_date,
              createdAt: entry?.attributes?.createdAt,
              updatedAt: entry?.attributes?.updatedAt,
            };
          }),
        );

        console.log('original Data:', responseData);
        console.log('current Data after modification:', data1);

        setData(filterGlobalSearch(data1, searchText, filterScope));
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // selecting the dropdowns data
  const fetchSesson = async (token) => {
    let seasonData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/seasons?sort=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const seasonData = await response.json();

      if (seasonData.error) {
        errorHandler(seasonData, message);
      } else {
        seasonData2 = seasonData.data.map((entry) => {
          return {
            id: entry.id,
            season_type: entry.attributes.season_type,
            season_year: entry.attributes.season_year,
            season_id: entry.attributes.season_id,
            // launch_masters: entry.attributes.launch_masters,
          };
        });

        setOptionList(seasonData2);
        console.log('original Season Data:', seasonData);
        console.log('modified Data:', seasonData2);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  }; // end function fetchSeason

  // on first load do this
  useEffect(() => {
    if (authToken) {
      fetchSesson(authToken);
      fetchData(authToken);
    }
  }, []);

  // for opening add or edit form with data or change in the reference of design form when form is closed or page is reloaded
  useEffect(() => {
    console.log(editData);
    dataform?.setFieldsValue(editData);
  }, [editData, dataform]);

  useEffect(() => {
    if (searchText == '') {
      fetchData(authToken);
    } else {
      fetchData(authToken);
    }
  }, [searchText, filterScope]);

  // show add/edit form inside modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // hide and reset add/edit form inside modal
  const handleOk = () => {
    dataform.resetFields();
    setEditData(null);
    setIsModalOpen(false);
  };

  // hide and reset add/edit form inside modal
  const handleCancel = () => {
    dataform.resetFields();
    setEditData(null);
    setIsModalOpen(false);
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  //add record to database table by api call
  const addNewProductSpecification = async (data) => {
    setSaving(true);

    //add or removing extra data from values from formData object
    const values = {
      ...data,
      // 'LaunchDate': data['launchDate'].format('YYYY-MM-DD')
      launchId: uuidv4(),
      season: data.season,
    };

    data = { data: values };

    console.log('data:', data);
    console.log('values:', values);
    // return;
    //editId will be present only in case of edit mode
    console.log('data edit:', data.data.editId);

    if (data.data.editId) {
      console.log('edit id :', data.data.editId);
      // update the record
      try {
        const response = await fetch(
          `${API}/launch-masters/${data.data.editId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',

              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
          },
        );
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          errorHandler(responseData, message);
        } else {
          message.success('Data saved successfully!');

          // tbm
          fetchData(getToken());
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        handleOk();
      }
    } else {
      // create a new record in the database table
      console.log('edit id :', data.editId); //should be falsy
      data.data = { ...data.data, business_date: data.data.launchDate };
      console.log('data to be sent for creation:', data);
      // return false;
      try {
        const response = await fetch(`${API}/launch-masters/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          errorHandler(responseData, message);
        } else {
          message.success('Data saved successfully!');
          //
          fetchData(getToken());
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        handleOk();
      }
    }
  };

  const columns = [
    {
      key: 'launchName',
      title: 'Launch Name',

      // render method for rendering customized values in the table cell
      render: (record) => {
        console.log(record);
        // if()
        return (
          <div>
            {user.rolesAssigned.find((role) =>
              userRolesAllowedForFeature?.view?.generateDoc?.includes(role),
            ) ? (
              <a
                onClick={() => {
                  toGenerateSheet(record.id);
                }}
              >
                {record.launchName}
              </a>
            ) : (
              record.launchName
            )}
          </div>
        );
      },
    },
    {
      key: 'launchDate',
      title: 'Proposed Date',
      render: (record) => {
        return moment(record?.launchDate).format('DD/MM/YYYY');
      },
    },
    {
      key: 'business_date',
      title: 'Business Date',
      render: (record) => {
        return record?.business_date
          ? moment(record?.business_date).format('DD/MM/YYYY')
          : '';
      },
    },
    {
      key: 'launchMonth',
      title: 'Launch Month',
      dataIndex: 'launchMonth',
    },
    {
      key: 'season',
      title: 'Launch Season',
      render: (record) => {
        console.log(record, 'season check');
        return (
          <div>
            {' '}
            {record?.seasonDetails?.seasonID
              ? record?.seasonDetails?.seasonID
              : 'NA'}
          </div>
        );
      },
    },

    {
      key: 'userName',
      title: 'Username',
      dataIndex: 'userName',
      render: (_, record) => {
        console.log(record, record?.userDetails?.userName);
        return record?.userDetails?.userName ?? 'NA';
      },
    },
    {
      key: 'createdAt',
      title: 'Created-Date',
      dataIndex: 'createdAt',
      render: (_, record) => {
        // console.log(record, record?.userDetails?.userName);
        return moment(record?.createdAt).format('DD/MM/YYYY') ?? 'NA';
      },
    },
    {
      key: 'action',
      title: 'Actions',
      render: (record) => {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                style={{ color: 'black' }}
                onClick={() => Edit(record)}
              />

              <DeleteOutlined
                style={{ color: 'red' }}
                onClick={() => Delete(record)}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const deleteDesignMasterEntry = async (recordID) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/launch-masters/${recordID}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const Delete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this',
      onOk: () => {
        deleteDesignMasterEntry(record.id);
      },
    });
  };

  const Edit = (record) => {
    setEditData({
      launchName: record?.launchName,
      launchId: record?.launchId,
      launchDate: moment(record?.launchDate, 'YYYY-MM-DD hh:mm:ss'), // date convertion to accepted format
      business_date:
        (record?.business_date && moment(record?.business_date)) || null,
      merch_complete_date:
        (record?.merch_complete_date && moment(record?.merch_complete_date)) ||
        null,
      planning_complete_date:
        (record?.planning_complete_date &&
          moment(record?.planning_complete_date)) ||
        null,
      design_complete_date:
        (record?.design_complete_date &&
          moment(record?.design_complete_date)) ||
        null,
      launchMonth: record?.launchMonth,
      season: record?.seasonDetails?.seasonRefId,
      launchDrop: record?.launchDrop,
      launchCat: record?.launchCat,
      editId: record?.id, // its important for edit functionality
    });
    // console.log(moment(record));
    console.log(moment(record?.launchDate));
    showModal(); // after setting the data for the edit form show the modal
  };

  const monthListOptions = monthNames.map((month, index) => {
    return {
      label: month,
      value: month,
    };
  });

  const handleTableChange = (pagination, filters, sorter) => {
    console.log('in handle table change', pagination, filters, sorter);
    const { order, columnKey } = sorter;
    setFilterInfo(filters);
    setSortedInfo({ columnKey, order });
  };

  //reset table
  const resetTable = () => {
    setSortedInfo({});
    setFilterInfo({});
    setSearchText('');
    setFilterScope('all');
    setAlreadySelectedRows([]);
    fetchData(authToken);
  };

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilterScopeChange = (value) => {
    console.log('setFilterScope', value);
    setFilterScope(value);
  };

  const getFilterOptionArray = (options) => {
    return options.map((option) => {
      return { value: option, label: option };
    });
  };

  const filterOptionArray = [...getFilterOptionArray(filterScopeOptionsArray)];

  const getFormattedData = () => {
    const downloadData = Data;
    // console.log(downloadData, 'downloading data...');

    let downloadDataFormatted = downloadData?.map((row) => {
      // console.log(row, 'downloading data row...');
      return {
        id: row.id,
        'Launch Name': row?.launchName,
        launchMonth: row?.launchMonth,
        'Proposed Date': moment(row?.launchDate).format('DD/MM/YYYY') ?? 'NA',
        'Business Date':
          moment(row?.business_date).format('DD/MM/YYYY') ?? 'NA',
        launchDrop: row?.launchDrop,
        season: row?.seasonDetails?.seasonID,
        userName: row?.userDetails?.userName,
        CreatedDate: moment(row?.createdAt).format('DD/MM/YYYY') ?? 'NA',
      };
    });

    // console.log(downloadDataFormatted, 'downloading data 2...');
    return downloadDataFormatted;
  };

  return (
    <div>
      <div>Launch Management</div>

      <Button onClick={showModal}>Add New Launch </Button>

      <div className="table">
        {/* Filter Search Section */}
        <div className="filterContainer">
          <div className="tableSearchSection">
            <Select
              defaultValue="all"
              className="filterScopeSelect"
              onChange={handleFilterScopeChange}
              options={filterOptionArray}
            />

            <Input
              placeholder="Enter Search Text"
              onChange={handleChangeSearch}
              type="text"
              allowClear
              value={searchText}
            ></Input>
            <Button onClick={resetTable}>Reset</Button>
            <Button style={{ backgroundColor: 'greenyellow', color: 'white' }}>
              <CSVLink
                data={getFormattedData()}
                filename={
                  'launch-Master-list-' +
                  moment(new Date()).format('DD-MM-YYYY')
                }
              >
                Download
              </CSVLink>
            </Button>
          </div>
        </div>
        {isLoading ? (
          <Spin size="large" />
        ) : (
          <Table
            dataSource={Data}
            columns={columns}
            onChange={handleTableChange}
            pagination={{ position: ['bottomCenter'] }}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: alreadySelectedRows,
              onChange: (keys) => {
                setAlreadySelectedRows(keys);
              },
              onSelect: (record) => {
                console.log(record, 'selected row ');
              },
              selections: [Table.SELECTION_NONE, Table.SELECTION_ALL],
            }}
          />
        )}
      </div>

      <Modal
        title="Add New Launch Details"
        visible={isModalOpen}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
      >
        <Card className="addProduct_page_card">
          <Form
            form={dataform}
            layout="vertical"
            onFinish={addNewProductSpecification}
          >
            <Row gutter={[16, 16]}>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Launch Name"
                  name="launchName"
                  rules={[
                    {
                      required: true,
                      message: 'Launch Name is Required!',
                      type: 'string',
                    },
                  ]}
                >
                  <Input
                    placeholder="Launch Name"
                    disabled={
                      !(editData?.editId
                        ? editData?.editId &&
                          user?.rolesAssigned?.find((role) =>
                            userRolesAllowedForFeature?.edit?.designHeadAttribute?.includes(
                              role,
                            ),
                          )
                        : user.rolesAssigned.find((role) =>
                            userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                              role,
                            ),
                          ))
                    }
                  />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Proposed Date"
                  name="launchDate"
                  rules={[
                    {
                      required: true,
                      message: 'Proposed Date is Required!',
                      type: 'object',
                    },
                  ]}
                >
                  <DatePicker
                    format={dateFormat}
                    disabled={
                      !(editData?.editId
                        ? editData?.editId &&
                          user?.rolesAssigned?.find((role) =>
                            userRolesAllowedForFeature?.edit?.designHeadAttribute?.includes(
                              role,
                            ),
                          )
                        : user.rolesAssigned.find((role) =>
                            userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                              role,
                            ),
                          ))
                    }
                  />
                </Form.Item>
              </Col>
              {/*
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    label="Launch Month"
                    name="launchMonth"
                    rules={[
                      {
                        type: 'string',
                      },
                    ]}
                  >
                    <Input placeholder="Launch Month" 
                    disabled={
                      !(editData?.editId
                        ? editData?.editId &&
                          user?.rolesAssigned?.find((role) =>
                            userRolesAllowedForFeature?.edit?.designHeadAttribute?.includes(
                              role,
                            ),
                          )
                        : user.rolesAssigned.find((role) =>
                            userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                              role,
                            ),
                          ))
                    }
                    />
                  </Form.Item>
                </Col>
                */}

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Launch Month"
                  name="launchMonth"
                  rules={[
                    {
                      required: true,
                      message: 'Month is Required!',
                    },
                  ]}
                >
                  {
                    <Select
                      options={monthListOptions}
                      showSearch
                      disabled={
                        !(editData?.editId
                          ? editData?.editId &&
                            user?.rolesAssigned?.find((role) =>
                              userRolesAllowedForFeature?.edit?.designHeadAttribute?.includes(
                                role,
                              ),
                            )
                          : user.rolesAssigned.find((role) =>
                              userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                                role,
                              ),
                            ))
                      }
                    />
                  }
                </Form.Item>
              </Col>

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Launch Drop"
                  name="launchDrop"
                  rules={[
                    {
                      required: true,
                      message: 'Launch Drop Code is Required!',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Launch Drop"
                    disabled={
                      !(editData?.editId
                        ? editData?.editId &&
                          user?.rolesAssigned?.find((role) =>
                            userRolesAllowedForFeature?.edit?.designHeadAttribute?.includes(
                              role,
                            ),
                          )
                        : user.rolesAssigned.find((role) =>
                            userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                              role,
                            ),
                          ))
                    }
                  >
                    <Select.Option value="L1">L1</Select.Option>
                    <Select.Option value="L2">L2</Select.Option>
                    <Select.Option value="L3">L3</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Launch Categories"
                  name="launchCat"
                  rules={[
                    {
                      required: true,
                      message: 'Launch Categories is Required!',
                      type: 'string',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Launch Category"
                    disabled={
                      !(editData?.editId
                        ? editData?.editId &&
                          user?.rolesAssigned?.find((role) =>
                            userRolesAllowedForFeature?.edit?.designHeadAttribute?.includes(
                              role,
                            ),
                          )
                        : user.rolesAssigned.find((role) =>
                            userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                              role,
                            ),
                          ))
                    }
                  >
                    <Select.Option value="Regular">Regular</Select.Option>
                    <Select.Option value="Super">Super</Select.Option>
                    <Select.Option value="Ultra">Ultra</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item label="Launch Season" name="season">
                  <Select
                    placeholder="Select "
                    disabled={
                      !(editData?.editId
                        ? editData?.editId &&
                          user?.rolesAssigned?.find((role) =>
                            userRolesAllowedForFeature?.edit?.designHeadAttribute?.includes(
                              role,
                            ),
                          )
                        : user.rolesAssigned.find((role) =>
                            userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                              role,
                            ),
                          ))
                    }
                  >
                    {optionList.map((opt) => (
                      <Select.Option value={opt.id}>
                        {opt.season_id}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Divider orientation="left">Business Date</Divider>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Business Date"
                  name="business_date"
                  rules={[
                    {
                      type: 'object',
                    },
                  ]}
                >
                  <DatePicker
                    format={dateFormat}
                    disabled={
                      !user.rolesAssigned.find((role) =>
                        userRolesAllowedForFeature?.edit?.allHeadOnlyAttribute?.includes(
                          role,
                        ),
                      )
                    }
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left">Completion Date</Divider>
              {/*
                  // Design Complete Date Field to mark all sku in this launch is complete with design data.
              */}

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Design Complete Date"
                  name="design_complete_date"
                  rules={[
                    {
                      type: 'object',
                    },
                  ]}
                >
                  <DatePicker
                    format={dateFormat}
                    disabled={
                      !user.rolesAssigned.find((role) =>
                        userRolesAllowedForFeature?.edit?.designAttribute?.includes(
                          role,
                        ),
                      )
                    }
                  />
                </Form.Item>
              </Col>

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="merch Complete Date"
                  name="merch_complete_date"
                  rules={[
                    {
                      type: 'object',
                    },
                  ]}
                >
                  <DatePicker
                    format={dateFormat}
                    disabled={
                      !user.rolesAssigned.find((role) =>
                        userRolesAllowedForFeature?.edit?.merchAttribute?.includes(
                          role,
                        ),
                      )
                    }
                  />
                </Form.Item>
              </Col>

              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="planning Complete Date"
                  name="planning_complete_date"
                  rules={[
                    {
                      type: 'object',
                    },
                  ]}
                >
                  <DatePicker
                    format={dateFormat}
                    disabled={
                      !user.rolesAssigned.find((role) =>
                        userRolesAllowedForFeature?.edit?.planningAttribute?.includes(
                          role,
                        ),
                      )
                    }
                  />
                </Form.Item>
              </Col>

              <Form.Item label="" hidden={true} name="editId">
                <Input type="text" />
              </Form.Item>
            </Row>
            <Button
              className="addProduct_save_btn"
              htmlType="submit"
              type="primary"
              size="large"
            >
              {saving ? (
                <>
                  <Spin size="small" /> Saving
                </>
              ) : (
                'Save'
              )}
            </Button>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};

export default LaunchMaster;
